var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "title"
  }, [_c("span", [_vm._v(_vm._s(_vm.title))]), _c("div", {
    staticClass: "under-line"
  })]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };